import * as d from './dependencies';
import * as m from './modules';

export const dependencies = d;
export const modules = m;
